/* JOGR: Kampanj "Batteri pa kopet" - global auto-add av gavan i varukorgen + dubblettsparr.
   Lyssnar pa Dawns cartUpdate-event (product-form = bade produktsidans ATC och kortens
   snabbkop pa kategori/sok/startsida). Taggkollar den tillagda produkten via /products/<handle>.js
   sa att taggen batteri-pa-kopet forblir enda sanningskallan. En gava per order, dubbleras inte.

   Dubblettsparren: gavan laggs som EGEN rad (property Kampanj) och slas darfor inte ihop med en
   rad kunden lagt till sjalv - t.ex. tillbehorskrysset i Selleasy pa produktsidan. Kunden fick da
   tva batterier medan BxGy-rabatten bara tacker ett. Nar gavoraden finns tas kundens extrarad med
   samma variant bort igen. Vill nagon anda ha tva hojer de antalet pa gavoraden.
   Vid ny kampanj: byt TAG och GIFT_HANDLE har + i sections/na-pakopet.liquid + card-product.liquid. */
(function () {
  var TAG = 'batteri-pa-kopet';
  var GIFT_HANDLE = 'pulsar-aps-3-batteripack';
  var GIFT_PROP = 'Kampanj'; /* JOGR: propertyn som gor gavoraden identifierbar */
  var FLAG = 'na-pakopet-gift';
  var CART_RE = /\/cart\/(add|change|update)/;
  var busy = false;
  var deduping = false;
  var internal = false;
  var timer = null;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* JOGR: sessionsflagga sa att sidladdnings-stadningen bara kostar ett cart.js-anrop
     for kunder som faktiskt fatt en gava - inte for varje besokare pa varje sida. */
  function giftFlag(set) {
    try {
      if (set) sessionStorage.setItem(FLAG, '1');
      return sessionStorage.getItem(FLAG) === '1';
    } catch (e) {
      return set === true;
    }
  }

  function onCartUpdate(evt) {
    try {
      if (!evt || evt.source !== 'product-form' || busy) return;
      var d = evt.cartData || {};
      var item = (d.items && d.items[0]) || d;
      var handle = item.handle;
      if (!handle || handle === GIFT_HANDLE) return;
      busy = true;
      fetch(root() + 'products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!p || !p.tags || p.tags.indexOf(TAG) === -1) throw 'ej kampanj';
          return fetch(root() + 'products/' + GIFT_HANDLE + '.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (g) {
          if (!g || !g.available) throw 'gava slut';
          var v = null;
          for (var i = 0; i < g.variants.length; i++) { if (g.variants[i].available) { v = g.variants[i]; break; } }
          if (!v) throw 'gava slut';
          return fetch(root() + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var has = cart.items.some(function (it) { return it.variant_id === v.id; });
              if (has) throw 'redan i korgen'; /* JOGR: en per order */
              return fetch(root() + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: v.id, quantity: 1, properties: { 'Kampanj': 'Batteri på köpet' } }],
                  sections: 'cart-drawer,cart-icon-bubble',
                  sections_url: window.location.pathname
                })
              });
            });
        })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          giftFlag(true);
          var drawer = document.querySelector('cart-drawer');
          if (drawer && res && res.sections) drawer.renderContents(res);
          var note = document.querySelector('cart-notification');
          if (!drawer && note && res && res.sections) note.renderContents(res);
        })
        .catch(function () {})
        .then(function () { busy = false; });
    } catch (e) { busy = false; }
  }

  /* ---- Dubblettsparr ----------------------------------------------------- */

  function sectionsParam() {
    return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
  }

  function toast() {
    if (!document.getElementById('na-pakopet-toast-css')) {
      var st = document.createElement('style');
      st.id = 'na-pakopet-toast-css';
      st.textContent = '.na-pakopet-toast{position:fixed;left:50%;bottom:2.4rem;transform:translateX(-50%);z-index:1000;max-width:90vw;background:rgb(var(--color-foreground,17 17 17));color:rgb(var(--color-background,255 255 255));font-size:1.4rem;line-height:1.4;padding:1.2rem 1.6rem;border-radius:6px;box-shadow:0 2px 10px rgb(0 0 0/.25)}';
      document.head.appendChild(st);
    }
    var el = document.createElement('div');
    el.className = 'na-pakopet-toast';
    el.setAttribute('role', 'status');
    el.textContent = 'Batteriet ingår redan på köpet – vi tog bort dubbletten i varukorgen.';
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 6000);
  }

  function applySections(res, allowDrawer) {
    if (!res || !res.sections) return;
    /* JOGR: pa /cart finns inget vi kan byta ut punktvis - ladda om sa raden forsvinner pa riktigt */
    if (document.getElementById('main-cart-items')) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res.sections['cart-drawer'] && (allowDrawer || drawer.classList.contains('active'))) {
      drawer.renderContents(res);
      return;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && res.sections['cart-icon-bubble']) {
      var src = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (src) bubble.innerHTML = src.innerHTML;
    }
  }

  function dedupe(allowDrawer) {
    if (deduping) { schedule(allowDrawer); return; }
    deduping = true;
    internal = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftSeen = false;
        var extras = [];
        (cart.items || []).forEach(function (it, i) {
          if (it.handle !== GIFT_HANDLE) return;
          if (!giftSeen && it.properties && it.properties[GIFT_PROP]) { giftSeen = true; return; }
          extras.push(i + 1); /* JOGR: cart/change.js raknar rader fran 1 */
        });
        if (!giftSeen || !extras.length) return null;
        extras.sort(function (a, b) { return b - a; }); /* bakifran - radnumren forskjuts vid borttag */
        var chain = Promise.resolve(null);
        extras.forEach(function (line) {
          chain = chain.then(function () {
            return fetch(root() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: line,
                quantity: 0,
                sections: sectionsParam(),
                sections_url: window.location.pathname
              })
            }).then(function (r) { return r.json(); });
          });
        });
        return chain;
      })
      .then(function (res) { if (res) { applySections(res, allowDrawer); toast(); } })
      .catch(function () {})
      .then(function () { deduping = false; internal = false; });
  }

  function schedule(allowDrawer) {
    clearTimeout(timer);
    timer = setTimeout(function () { dedupe(allowDrawer); }, 250);
  }

  /* JOGR: appar (Selleasys tillbehorskryss) lagger i korgen utan att publicera Dawns cartUpdate.
     Darfor lyssnar vi passivt pa anrop mot cart/add|change|update - bara observation, anropen
     slapps igenom oforandrade och egna anrop hoppas over via internal-flaggan. */
  function hookNetwork() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input) {
        var p = nativeFetch.apply(this, arguments);
        try {
          var url = (input && input.url) || String(input || '');
          if (!internal && CART_RE.test(url) && p && typeof p.then === 'function') {
            p.then(function () { schedule(false); }, function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { this.__naCartCall = CART_RE.test(String(u || '')); } catch (e) {}
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (!internal && this.__naCartCall) this.addEventListener('load', function () { schedule(false); });
      } catch (e) {}
      return xhrSend.apply(this, arguments);
    };
  }

  function reg() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(true); });
    return true;
  }

  function start() {
    if (!reg()) document.addEventListener('DOMContentLoaded', reg);
    hookNetwork();
    /* JOGR: stada vid sidladdning ocksa - dubbletter fran ett tidigare besok ligger kvar i korgen.
       Bara nar vi vet att en gava lagts (sessionsflagga) eller nar kunden ar pa /cart. */
    if (giftFlag() || document.getElementById('main-cart-items')) schedule(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();